// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"337":"d080b984","345":"31222cf0","677":"31222cf0","894":"2f29883d"}[chunkId] + ".css";
};